module.exports = "/_next/static/images/Construction-d184d23294e0c62be07733c7d4bfc209.webp";